import { IMAGE_DOMAIN_BASE_URL, VIDEO_STORAGE } from '../constants';

export const buildR2VideoUrls = id => ({
  full: `${IMAGE_DOMAIN_BASE_URL}/${id}`,
  thumbnail: `${IMAGE_DOMAIN_BASE_URL}/${id}.webp`
});

const buildVideoLinks = (videoObject = {}) => {
  if (videoObject.poster_url || videoObject.thumbnail) {
    return {
      full: videoObject.secure_url || videoObject.url || videoObject.full,
      thumbnail: videoObject.poster_url || videoObject.thumbnail
    };
  }

  if (videoObject.storage === VIDEO_STORAGE.R2) {
    return buildR2VideoUrls(videoObject.id);
  }

  return {};
};

export default buildVideoLinks;
